<template>
<div class="chapter">
<div class="inner_page">
<div id="Diagrams">
<p class="fm-title" id="dia"><a id="pagexiii">List of Diagrams</a></p><a id="pagexiii">
<table border="0" cellpadding="0" cellspacing="0" style="margin-top:0.5em;" width="100%">
<colgroup>
<col width="07%"/>
<col width="93%"/>
</colgroup>
<tbody>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/13_Chapter03#dia3_1" title="Link target outside of Sample">3.1</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/13_Chapter03#dia3_1" title="Link target outside of Sample">Typical fire support. 88</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/14_Chapter04#dia4_1" title="Link target outside of Sample">4.1</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/14_Chapter04#dia4_1" title="Link target outside of Sample">Assault engineer tactics. 129</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/14_Chapter04#dia4_2" title="Link target outside of Sample">4.2</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/14_Chapter04#dia4_2" title="Link target outside of Sample">Typical German infantry strongpoint on Normandy coast. 129</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/14_Chapter04#dia4_3" title="Link target outside of Sample">4.3</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/14_Chapter04#dia4_3" title="Link target outside of Sample">Crossing of Seine. 139</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/14_Chapter04#dia4_4" title="Link target outside of Sample">4.4</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/14_Chapter04#dia4_4" title="Link target outside of Sample">Attack on Le Havre. 150</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/16_Chapter06#dia6_1" title="Link target outside of Sample">6.1</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/16_Chapter06#dia6_1" title="Link target outside of Sample">Airfield at Le Fresne (B5). 199</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/18_Chapter07#dia7_1" title="Link target outside of Sample">7.1</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/18_Chapter07#dia7_1" title="Link target outside of Sample">Dos and Don’ts of PW handling. 234</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/18_Chapter07#dia7_2" title="Link target outside of Sample">7.2</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/18_Chapter07#dia7_2" title="Link target outside of Sample">German coloured patches worn on shoulders to earmark branch of Army. 234</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/18_Chapter07#dia7_3" title="Link target outside of Sample">7.3</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/18_Chapter07#dia7_3" title="Link target outside of Sample">German Formation Signs. 235</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/20_Chapter09#dia9_1" title="Link target outside of Sample">9.1</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/20_Chapter09#dia9_1" title="Link target outside of Sample">Medical evacuation chain. 299</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/20_Chapter09#dia9_2" title="Link target outside of Sample">9.2</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/20_Chapter09#dia9_2" title="Link target outside of Sample">Typical layout of a Casualty Clearing Station. 303</span></p></td>
</tr>
<tr>
<td valign="top"><p class="noindent3"><span href="#/xhtml/31_AppendixH#diaH_1" title="Link target outside of Sample">H.1</span></p></td>
<td valign="top"><p class="noindent3"><span href="#/xhtml/31_AppendixH#diaH_1" title="Link target outside of Sample">Fire Support and Air Support during Operation BLUECOAT. 436</span></p></td>
</tr>
</tbody>
</table>
</a></div><a id="pagexiii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Diagrams.vue?2caa410b